export const projectsData=[
  {
    id:1,
    title: "VR and Unity Projects",
    des: "Chith Vihar is the School of Computing Block in SASTRA Deemed University. The project was done in Oculus Go where the user can experience the building's infrastructure. Asset design and creation was done in Tinker Cad and worked on optimization to increase the efficiency ",
    src: "VR.jpg",
    websiteLink: "/VRProjects",
  },

  {
    id:2,
    title: "3D Modeling and Animation",
    des: "A small todo app to add a list of check list items. Users can create,edit and delete the list of todo items",
    src: 'Garage.jpg',
    websiteLink: "/ModelingAnimation"
  },  
  {
    id:3,
    title: "Computational Photography",
    des: "Designed a small exploration game in Unity Game Engine for the users to view the University in Gaming. Models used in the project were made in Solid works and Tinker Cad",
    src: 'Atrium.jpg',
    websiteLink: "/Photography",
  },
  {
    id:4,
    title: "Web and App Development Projects",
    des: "Designed a small exploration game in Unity Game Engine for the users to view the University in Gaming. Models used in the project were made in Solid works and Tinker Cad",
    src: 'Cafe.png',
    websiteLink: "/WebDevProjects",
  },
  {
    id:5,
    title: "Tangible UI Projects",
    des: "A basic VR Fashion show that could help in promoting fashion products without the customers visiting the location. A 360 VR Video that was made using Unity and Mixamo  ",
    src: 'TangibleUI.png',
    websiteLink: "/TangibleUI"
  },
];

export const VRProjectsData=[

  {
    id:1,
    title: "Sky Pirates",
    des: "Centuries of human exploitation have left Earth barren of natural resources. In a fight for survival, humanity has fled to the skies."+
    "In this aerial domain, majestic yet perilous dragons roam freely, serving as the final source of sustenance in the sky. A VR Game where the task of the player is to fight against a dragon and survive.",
    githubLink: "https://drive.google.com/drive/folders/1fbwB62yGF9QObagc-3ubUoDyoj_pGeQq?usp=sharing",
    VideoLink: "https://www.youtube.com/watch?v=JVHyfT9JBFo",
  },
  {
    id:2,
    title: "Haunted House",
    des: "Step into the Haunted Manor VR experience and brace yourself to confront the darkest recesses of your mind as you traverse its haunted halls."+
    "But beware, for in this realm of the supernatural, reality is elusive, and the truth obscured by shadows."+
    "Are you courageous enough to unveil the secrets shrouded within its eerie confines?",
    githubLink: "https://drive.google.com/drive/folders/1IaZwuiDS0dgn5GlZmW4M6J0UtvGCISnH?usp=sharing",
    VideoLink: "https://www.youtube.com/watch?v=qgV68e42dzo",
  },
  
  {
    id:3,
    title: "Chith Vihar in VR",
    des: "Chith Vihar is the School of Computing Block in SASTRA Deemed University. The project was done in Oculus Go where the user can experience the building's infrastructure. Asset design and creation was done in Tinker Cad and worked on optimization to increase the efficiency ",
    VideoLink: "https://www.youtube.com/watch?v=weyd18y9PSs",
    githubLink: "https://github.com/ChowtooriKedari/APK-s"
  },
  {
    id:4,
    title: "VR Fashion Show",
    des: "A basic VR Fashion show that could help in promoting fashion products without the customers visiting the location. A 360 VR Video that was made using Unity and Mixamo  ",
    VideoLink: "https://www.youtube.com/watch?v=mfxuCUbvUno",
    githubLink: "https://github.com/ChowtooriKedari/VR-Fashion-Show_Basic"      
  },
  {
    id:5,
    title: "SASTRA Tour",
    des: "Designed and developed a small exploration game in Unity Game Engine for the users to view the University in Gaming. Models used in the project were made in Solid works and Tinker Cad",
    VideoLink: "https://www.youtube.com/watch?v=dWvws69O6Ck",
    githubLink:"https://github.com/ChowtooriKedari/SASTRA-Tour-Unity"
  },
  {
    id:6,
    title: "VR Space Exploration",
    des: "Designed and developed a VR project in Unity 3D for Oculus Go, offering an immersive space tour from rocket launch to a moon roller coaster ride with seamless scene transitions.",
    src: 'Space.png',
    githubLink:"https://github.com/ChowtooriKedari/VR-Space-Exploration"
  },
  {
    id:7,
    title: "Survival Game",
    des: "A small game developed in Unity using PlayMaker.This is a survival game where the player has to survive from the attack of the zombies.",
    src: 'Survival.png',
    githubLink:"https://github.com/ChowtooriKedari/Survival-Game---Unity"
  }
];

export const WebDevProjectsData=[
  {
    id:1,
    title: "Cafeteria",
    des: " An online food ordering and point-of-sale System made using Rails, HTML, CSS and PostgreSQL. Generates reports of all the sales between a speciﬁed period and the ﬁnancial transactions of a customer to the cafeteria Application",
    src: 'Cafe.png',
    githubLink: "https://github.com/ChowtooriKedari/cafe_management"
  },
  {
    id:2,
    title: "Todo Manager",
    des: "A small todo app to add a list of check list items. Users can create,edit and delete the list of todo items",
    src: 'Todo.png',
    githubLink: "https://github.com/ChowtooriKedari/todo_manager"
  },
  {
    id:3,
    title: "HOP Art History Timeline Website",
    des: "Hop Arts history timeline is an interactive digital timeline I developed for the Hopkins Center for the Arts at Dartmouth. Built using Angular and JavaScript, the website showcases the rich history of student art and performances on campus.",
    src: 'hopArtsWebsite.png',
    githubLink: "https://github.com/ChowtooriKedari/Hop_TimeLine_New",
    attachmentLink: "https://hop-time-line-new.vercel.app"
  },
  {
    id:4,
    title: "HOP Pepper's Ghost",
    des: "Pepper’s Ghost App is a mobile experience I developed as part of the Hopkins Center for the Arts project at Dartmouth. Designed using React Native, the app enables users to view pre-recorded student performances as holographic illusions using the classic Pepper’s Ghost technique. It includes an admin upload feature (for internal use only) and a viewer mode that brings digital content to life through a minimalist interface.",
    src: 'mobileApp.jpg',
    githubLink: "https://github.com/ChowtooriKedari/HOPPepperGhost",
    attachmentLink: "https://apps.apple.com/us/app/peppers-ghost/id6744206339?platform=iphone"
  }
];

export const ModelingandAnimationData=[
  {
    id:1,
    title: "Oreo - The Robot",
    des: "I've created a 3D robot model in Maya and rigged it for animation. The eyes are animated with multiple keyframes, displaying various expressions. The animation concludes with a walk cycle, bringing the robot to life with fluid movements",
    githubLink: "https://github.com/ChowtooriKedari/Oreo_The-Robot",
    videoLink:'https://youtu.be/Yxfp1eGaiO8'
  },
  {
    id:2,
    title: "Dreams",
    des: "An animation depicting a child drifting off to sleep and entering a dream where he battles and defeats a deadly monster, only to be awakened by his teacher, realizing it was all a dream.",
    videoLink:'https://youtu.be/BMogO3i28oc',
  },
  {
    id:3,
    title: "Brothers",
    des: "An animation that illustrates the bond between brothers, from childhood days to sibling rivalry, highlighting moments of happiness, sorrow, and togetherness. Created using Maya and Motion Capture.",

    videoLink:'https://youtu.be/yJtsT4QvYUY'
  },
  {
    id:4,
    title: "The Garage",
    des: "Developed a three-dimensional room with a variety of components, including fixtures, furniture, and architectural features. Using Maya's modeling tools, each of these elements was carefully designed to get the appropriate looks and functionality inside the virtual environment."+
    "Textures from Adobe Substance were integrated into the models to improve the scene's tactile quality and visual authenticity. These textures were chosen with care to give the surfaces of the objects a realistic appearance of materials like metal, wood, cloth, or glass, giving the scene more depth and realism."+
    "The goal was to build an engaging and realistic virtual room that captivates visitors and communicates a sense of realism and coherence by combining the capabilities of Maya for 3D modeling with Adobe Substance for texture creation",
    src: 'Garage.jpg',
    githubLink: "https://github.com/ChowtooriKedari/The-Garage",
  }
];
export const PhotographyData=[
 {
    id:1,
    title: "unstructured light field",
    des: "An unstructured light field refers to a method of capturing light information from a scene without a fixed or regular arrangement of cameras or view points. This is different from the traditional light fields, that use a structured grid of cameras. The unstructured light field approach can provide more flexibility in capturing complex scenes and is usually used in applications like computer vision, virtual reality and image based rendering.",
    src: 'LightFieldCameraSetup.jpg',
    githubLink: "https://github.com/ChowtooriKedari/Unstructured-Light-Field/tree/main/Unstructured%20Light%20Field",
    attachmentLink: "https://drive.google.com/file/d/1vG6ODmV-8hXwc0T023dwbm3c_ijt1KGE/view?usp=sharing"
  }
];
export const TangibleUIData=[
  {
    id:1,
    title:"Servo Motors and Piezo Buzzers",
    videoLink: "https://youtu.be/SOgFboEk9ok"
  },
  {
    id:2,
    title:"Music with sensors",
    videoLink: "https://youtu.be/oiQg7bAIGyA"
  },
  {
    id:3,
    title:"Sensors and Unity Game Engine",
    videoLink: "https://youtu.be/lSsmz0CHRgg"
  },
  {
    id:4,
    title:"Mini Halloween",
    videoLink: "https://youtu.be/aEIELRoJjlw"
  },
  {
    id:5,
    title:"Arduino and DC Motors",
    videoLink: "https://youtu.be/PrXBut52AFA"
  },
  {
    id:6,
    title:"LEDs and Piezo Buzzers",
    videoLink: "https://youtu.be/Tz8ORqOJswA"
  },
  {
    id:7,
    title:"Arduino and LEDs",
    videoLink: "https://youtu.be/WVHvqrBwxjQ"
  }
];
export const workExperiences= [
    {
    _id: 6,
    title: "Research Assistant",
    subTitle: "Dartmouth College - (06/2024 - 06/2025)",
    location: "Hanover, NH",
    description: [
      " Member of RISC lab and worked on my masters thesis titled \"A Highspeed Imaging Framework Using Sparse Sampling And Generative Priors\"",
      " Designed a novel high-speed imaging system to capture phenomena invisible to the human eye ",
      " Addressed bandwidth limitations in traditional imaging by integrating generative AI for reconstructing high-resolution images ",
      " Combined fast data acquisition with intelligent reconstruction, enabling detailed imaging from minimal sensor input ",
      " Leveraged a single-pixel detector and advanced scanning techniques to optimize performance and scalability "
    ],
    img: 'Dartmouth.png',
  },
  {
    _id: 5,
    title: "Teaching Assistant",
    subTitle: "Dartmouth College - (06/2024 - 06/2025)",
    location: "Hanover, NH",
    description: [
      " Assisted in teaching and supporting coursework for the following graduate-level classes: Computer Graphics, Digital Fabrication, AR/VR Development, Tangible User Interfaces, and Computational Photography",
      " Support students in understanding course concepts and completing assignments",
      " Lead lab sessions and provide one-on-one assistance to students",
      " Aid in grading assignments and developing course materials"
    ],
    img: 'Dartmouth.png',
  },
  {
    _id: 4,
    title: "Hop Fellow",
    subTitle: "Hopkins Center for the Arts at Dartmouth - (09/2023 - 06/2025)",
    location: "Hanover, NH",
    description: [
      " Serve as a member of the research team, focusing on developing an interactive timeline (https://hop-time-line-new.vercel.app) to showcase Dartmouth’s art history",
      " Work on building a website using Angular and JavaScript for the timeline project",
      " Contribute to organizing various student events across campus, including the Hanunder Student Festival",   
      " Developed an app (https://apps.apple.com/us/app/peppers-ghost/id6744206339) to showcase the student's 3D Modeling art work during the Hanunder Student Festival"
  ],
    img: 'HOP.png',
  },
    {
      _id: 3,
      title: "Software Engineer",
      subTitle: "Blackhawk Network - (03/2023 - 07/2023)",
      location: "Bangalore, India",
      description: [
      " Developed web page functionalities for the Business Gift Card Store Project using JavaScript, jQuery, and Angular as part of the Platforms-Shared Services Product Line",
      " Implemented server-side pagination to optimize API requests, reducing server load by 30% and improving overall system performance by 25% through prioritized server calls",
      " Designed and executed test cases with NUnit and MoQ, achieving 80% code coverage and ensuring compliance with the Software Development Life Cycle (SDLC)", 
      " Enhanced user experience by ensuring cross-browser compatibility and creating a mobile-responsive design for seamless functionality on smartphones and tablets",
      " Collaborated with database and infrastructure teams during User Acceptance Testing (UAT) and production deployments, ensuring smooth releases with reduced deployment issues",
      " Managed CI/CD workflows using Bitbucket, SourceTree, and Octopus Deploy, ensuring efficient version control, branch management, and seamless deployments across multiple environments"
      ],
      img: 'BHN.jpg',
    },
    {
      _id: 2,
      title: "Associate Software Engineer",
      subTitle: "Blackhawk Network - (11/2021 - 03/2023)",
      location: "Bangalore, India",
      description: [
      " Contributed to the Platforms-Shared Services team, supporting internal initiatives and the Business Gift Card Store project",
      " Designed and developed a web application using Microsoft Graph API and Azure AD to streamline the employee inquiry process, reducing response time by 40%",
      " Leveraged data insights to optimize application performance, achieving a 20% improvement while enhancing database scripts to boost query efficiency by 30%",
      " Developed and fine-tuned web services for efficient data retrieval, reducing API response times by 25%",
      " Conducted unit testing to ensure functionality and used JMeter scripts for performance testing, improving application"
      ],
      img: 'BHN.jpg',
    },
    {
      _id: 1,
      title: "Intern",
      subTitle: "Hewlett Packard - (02/2021 - 08/2021)",
      location: "Bangalore, India",
      description: [
       " Supported the .NET Product Content Development Team by developing and maintaining software for Product Content Management",
       " Executed tasks such as coding, testing, debugging, and documenting software components, increasing module efficiency by 15%",
       " Built webservices to retrieve and display product catalog information, ensuring comprehensive documentation for seamless integration",
       " Worked on Rule Engine-based project that helped product owners determine which products and descriptions to display in the catalog, optimizing code to enhance performance",
       " Performed unit and integration testing to identify and resolve issues, improving software reliability by 20%"
   ],
   img: 'HP.png',
    },
  ];


  
